var _polygon, _g, _g2, _polygon2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReligionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E89419",
    points: "41,32 24,26 7,32 7,44 41,44 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    fill: "#FFC107",
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    fill: "#FFC107",
    width: 6,
    height: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M17,37.001c0-2.668-4-5-4-5s-4,2.332-4,5C9,39.667,9,44,9,44h8C17,44,17,39.667,17,37.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M39,37.001c0-2.668-4-5-4-5s-4,2.332-4,5C31,39.667,31,44,31,44h8C39,44,39,39.667,39,37.001z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFB74D",
    points: "29,44 19,44 19,24 24,19 29,24 \t"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E64A19",
    points: "23,11 25,11 29,24 24,19 19,24 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BF360C",
    points: "19,25.872 5.638,31.068 6.362,32.932 19,28.018 \t"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BF360C",
    points: "29,25.872 29,28.018 41.638,32.932 42.362,31.068 \t"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#BF360C",
    strokeWidth: 2,
    points: "18,24 24,18 30,24 \t"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#805A26",
    cx: 13,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#805A26",
    d: "M12,39c0-1-1-2-1-2s-1,1-1,2s0,5,0,5h2C12,44,12,40,12,39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#805A26",
    d: "M16,39c0-1-1-2-1-2s-1,1-1,2s0,5,0,5h2C16,44,16,40,16,39z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#805A26",
    cx: 35,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#805A26",
    d: "M34,39c0-1-1-2-1-2s-1,1-1,2s0,5,0,5h2C34,44,34,40,34,39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#805A26",
    d: "M38,39c0-1-1-2-1-2s-1,1-1,2s0,5,0,5h2C38,44,38,40,38,39z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#805A26",
    cx: 24,
    cy: 25,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#805A26",
    d: "M27,39c0-2-3-4-3-4s-3,2-3,4s0,5,0,5h6C27,44,27,41,27,39z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReligionIcon);
export default __webpack_public_path__ + "static/media/religion_icon.3ef39c505ded0da464373ec5b71f8a34.svg";
export { ForwardRef as ReactComponent };